import { render, staticRenderFns } from "./ModeSwitcher.vue?vue&type=template&id=a368af08"
import script from "./ModeSwitcher.vue?vue&type=script&lang=js"
export * from "./ModeSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports